module.exports = __webpack_public_path__ + "static/media/first-banner-mobile.8a58c53a.png";